import { toast } from 'react-toastify';
import { AI_ADDON_CALL_TEMPLATE } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const fetchAIAddonCallTemplateTableAndFilterSchema = async (data = {}) => {
    try {
        const url = data?._Id
            ? `${AI_ADDON_CALL_TEMPLATE.GET_AI_ADDON_CALL_TEMPLATE_SCHEMA}/${data?._Id}`
            : `${AI_ADDON_CALL_TEMPLATE.GET_AI_ADDON_CALL_TEMPLATE_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitAIAddonCallTemplateFilterData = async (data = {}) => {
    try {
        const response = await POST(AI_ADDON_CALL_TEMPLATE.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getAIAddonCallTemplateDefinitions = async (data = {}) => {
    try {
        const response = await GET(AI_ADDON_CALL_TEMPLATE.GET_DEFINITIONS, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getAIAddonCallTemplateById = async (id, data = {}) => {
    try {
        const response = await GET(AI_ADDON_CALL_TEMPLATE.GET_AI_ADDON_CALL_TEMPLATE_BY_ID(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const addAIAddonCallTemplate = async (data = {}) => {
    try {
        const response = await POST(AI_ADDON_CALL_TEMPLATE.ADD_AI_ADDON_CALL_TEMPLATE, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateAIAddonCallTemplate = async (id, data = {}) => {
    try {
        const response = await PUT(AI_ADDON_CALL_TEMPLATE.UPDATE_AI_ADDON_CALL_TEMPLATE(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
